import classNames from 'classnames';
import React from 'react';
import { FormField } from '../../../model/form';
import { Stack } from '../../Stack/Stack';
import { Radio } from './Radio';

interface RadioOption<T> {
  label: string;
  value: T;
  checked?: boolean;
}

interface Props<T extends string> extends FormField<T | null> {
  options: RadioOption<T>[];
  name: string;
  layout?: 'row' | 'list';
}

export function FormRadioGroup<T extends string>({
  onChange,
  name,
  value,
  options,
  layout = 'row',
}: Props<T>): JSX.Element {
  return (
    <Stack className={classNames('radio-group', `radio-group--${layout}`)} line={layout === 'row'} size="lg">
      {options.map((option) => (
        <Radio<T>
          name={name}
          key={option.label}
          label={option.label}
          value={option.value}
          checked={option.checked || option.value === value}
          onChange={(val) => onChange?.(val)}
        />
      ))}
    </Stack>
  );
}
